import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './Copyright.scss';

interface Props {
    className?: string;
}
export const Copyright: FC<Props> = ({ className }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className={`copyright ${className ? className : ''}`}> {t('footer.copyright')}</div>
        </>
    );
};
